<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width500 full-height" header="Optionen">
        <sm-toolbar>
            <p-splitButton icon="fas fa-tower-broadcast" label="Verbindung laden ..." [model]="connectionItems" (onClick)="loadConnection()" (onDropdownClick)="updateConnectionItems()"></p-splitButton>
            <button pButton icon="fas fa-database" label="ODBC konvertieren" (click)="odbcToRaw()"></button>
        </sm-toolbar>
        <app-config-editor-tree #configEditorTree [def]="def" [showInfoColumn]="false" [propColumnWidth]="'250px'">
        </app-config-editor-tree>
        <p-button class="mt-3" icon="fas fa-database" label="Als JSON in Zwischenablage kopieren" (onClick)="copyJsonToClipboard()"></p-button>
    </p-panel>
    <p-tabView class="flex-item-fill height100p full-height direct-sub">
        <p-tabPanel header="Verschiedenes">
            <sm-toolbar>
                <p-button icon="fas fa-database" label="Datenbank in DBeaver öffnen" (onClick)="openDbeaver()"></p-button>
            </sm-toolbar>
        </p-tabPanel>
        <p-tabPanel header="Query">
            <div class="flex-row-split height100p">
                <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
                    <sm-form  [form]="queryForm">
                    </sm-form>
                    <p-button class="mt-3" icon="fas fa-search" label="Finden" (onClick)="query()"></p-button>
                </p-panel>
                <sm-table2 *ngIf="queryTable != null" class="flex-item-fill height100p" [data]="queryTable"></sm-table2>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Werte finden">
            <div class="flex-row-split height100p">
                <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
                    <sm-form  [form]="findValueForm">
                    </sm-form>
                    <p-button class="mt-3" icon="fas fa-search" label="Finden" (onClick)="findValues()"></p-button>
                </p-panel>
                <sm-table2 *ngIf="findValueTable != null" class="flex-item-fill height100p" [data]="findValueTable"></sm-table2>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Dump">
            <div class="flex-row-split height100p">
                <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
                    <sm-form  [form]="dumpForm">
                    </sm-form>
                    <p-button class="mt-3" icon="fas fa-clone" label="Dump" (onClick)="dump()"></p-button>
                </p-panel>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Vergleich">
            <div class="flex-row-split height100p">
                <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
                    <p-button class="block mb-3" icon="fas fa-redo-alt" label="Dumps neu laden" (onClick)="reloadDumps()"></p-button>
                    <sm-form  [form]="compareForm">
                    </sm-form>
                    <p-button class="mt-3" icon="fas fa-code-compare" label="Vergleichen" (onClick)="compare()"></p-button>
                </p-panel>
                <textarea pInputTextarea spellcheck=false class="flex-item-fill overflow-y-auto width100p height100p monospace no-resize" [ngModel]="changes"></textarea>
            </div>
        </p-tabPanel>
    </p-tabView>

</div>
<app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
